import React from "react"
import MSubscriptions from "./m_subscriptions"
import MUserTasks from "./m_user_tasks"
import MDfbNetLink from "./m_dfbnet_link"
import MUserApplications from "./m_applications"

const UserPanel = props => {
  const type = props.data.user_panel_module

  switch (type) {
    case "category": {
      return MSubscriptions({
        headline: props.data.headline || "Meine Abonnements",
        title: props.data.subheadline || "Abonnements und E-Mail-Benachrichtigungen verwalten",
      })
    }
    case "online-campus-tasks": {
      return MUserTasks({
        headline: props.data.headline || "Meine Aufgaben im Online-Campus",
      })
    }
    case "dfbnet-link": {
      return MDfbNetLink({
        headline: props.data.headline || "DFBnet-Verknüpfung",
      })
    }
    case "applications": {
      return MUserApplications({
        headline: props.data.headline,
      })
    }
    default: {
      return <div>User panel "{type}" not implemented.</div>
    }
  }
}

export default UserPanel
